import { useState } from 'react'
import { Button } from '@/components/ui/Button'
import { readConsent, saveConsent, type ConsentChoice, type ConsentRecord } from '@/lib/consent'

export function CookieConsent() {
  const [record, setRecord] = useState<ConsentRecord | null>(readConsent)

  if (record !== null) {
    return null
  }

  const decide = (choice: ConsentChoice) => {
    setRecord(saveConsent(choice))
  }

  return (
    <div
      role="region"
      aria-label="Cookies"
      className="fixed bottom-4 left-4 z-30 flex w-[calc(100vw-2rem)] max-w-md flex-col gap-3 rounded-lg border border-border bg-surface p-4 shadow-lg sm:w-auto"
    >
      <div className="flex flex-col gap-1">
        <h2 className="text-base font-semibold text-ink">Cookies</h2>
        <p className="text-sm text-ink-muted">
          Signing in needs one technical cookie holding the session token — the partner space does
          not work without it, and it cannot be turned off. Everything else is on only with your
          consent.
        </p>
      </div>

      <div className="flex flex-wrap gap-2">
        <Button
          size="sm"
          onClick={() => {
            decide('all')
          }}
        >
          Accept all
        </Button>
        <Button
          size="sm"
          variant="secondary"
          onClick={() => {
            decide('necessary')
          }}
        >
          Necessary only
        </Button>
      </div>
    </div>
  )
}
